
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ChatMessageImageDialog extends Vue {
  @Prop() private url!: string;
  private visible: boolean = true;

  private destroyComponent(): void {
    this.$emit('close');
  }
}
